import { Plus, Trash2 } from "lucide-react";
import { Input } from "../ui/input";
import { MAX_ITEMS, itemError, newItem } from "./compareOptions";

const COLS = [
  ["description", "Omschrijving", "col-span-5 order-1 sm:col-span-5", { maxLength: 80, placeholder: "Bijv. woonkamer voorzijde" }],
  ["width", "Breedte (cm)", "col-span-2 order-3 sm:col-span-2 sm:order-2", { inputMode: "numeric", maxLength: 5, placeholder: "bijv. 120" }],
  ["height", "Hoogte (cm)", "col-span-2 order-4 sm:col-span-2 sm:order-3", { inputMode: "numeric", maxLength: 5, placeholder: "bijv. 150" }],
  ["quantity", "Aantal", "col-span-2 order-5 sm:col-span-2 sm:order-4", { inputMode: "numeric", maxLength: 2, placeholder: "1" }],
];

const SizeRow = ({ item, index, onChange, onRemove, canRemove }) => {
  const err = itemError(item);
  return (
    <li className="rounded-xl border border-slate-200 bg-slate-50/60 p-3 sm:p-3.5" data-testid={`compare-item-${index}`}>
      <div className="grid grid-cols-6 gap-2 sm:grid-cols-12">
        {COLS.map(([k, label, cls, props]) => (
          <label key={k} className={`min-w-0 ${cls}`}>
            <span className="mb-1 block text-[12px] font-medium text-slate-500">{label}</span>
            <Input value={item[k]} onChange={(e) => onChange({ ...item, [k]: e.target.value })} data-testid={`compare-item-${k}-${index}`}
              aria-label={`${label}, kozijn ${index + 1}`} className="h-11 rounded-lg border-slate-300 bg-white text-[15px]" {...props} />
          </label>
        ))}
        <div className="order-2 col-span-1 flex items-end justify-end sm:order-5 sm:col-span-1">
          {canRemove && (
            <button type="button" onClick={onRemove} aria-label={`Verwijder kozijn ${index + 1}`} data-testid={`compare-item-remove-${index}`}
              className="flex h-11 w-11 items-center justify-center rounded-lg text-slate-400 hover:bg-white hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
          )}
        </div>
      </div>
      {err && <p className="mt-1.5 text-[13px] font-medium text-red-600" role="alert" data-testid={`compare-item-error-${index}`}>{err}</p>}
    </li>
  );
};

export const SizeRows = ({ items, setItems }) => (
  <fieldset className="min-w-0">
    <legend className="mb-1 text-[14px] font-semibold text-ink">Kozijnen en maten <span className="font-normal text-slate-500">(optioneel)</span></legend>
    <p className="mb-3 text-[13px] text-slate-500">Globale maten zijn prima. Voeg per kozijn, pui of deur een regel toe.</p>
    <ul className="space-y-2.5" data-testid="compare-items">
      {items.map((it, i) => (
        <SizeRow key={it.key} item={it} index={i} canRemove={items.length > 1}
          onChange={(v) => setItems((list) => list.map((x) => (x.key === it.key ? v : x)))}
          onRemove={() => setItems((list) => list.filter((x) => x.key !== it.key))} />
      ))}
    </ul>
    {items.length < MAX_ITEMS && (
      <button type="button" onClick={() => setItems((list) => [...list, newItem()])} data-testid="compare-item-add"
        className="mt-3 inline-flex min-h-[44px] items-center gap-2 rounded-xl px-3 text-[14.5px] font-semibold text-maas hover:bg-maas-soft">
        <Plus className="h-4 w-4" aria-hidden="true" /> Nog een kozijn toevoegen
      </button>
    )}
  </fieldset>
);
